import * as React from "react";
import Big from "big.js";
import { observer } from "mobx-react";
import { DetailRowList } from "../..";
import { formatCurrency, orderTotals } from "@lib/common";
import { IoMdCloseCircleOutline } from "react-icons/io";
export const OrderTotals = observer((props) => {
    const { dishes, fees, feesRemovable, feesOnRemove, discounts, discountsRemovable, discountsOnRemove, promoCode, promoDiscount, total, cart, tip, rounded, hideCartTotalIfSame, hideTax, } = props;
    const adjustedCart = cart + rounded;
    const valueWithoutTax = parseInt(Big(total).div("1.15").toFixed(0), 10);
    const taxValue = total - valueWithoutTax;
    const totalsAreSame = adjustedCart === total;
    const details = [];
    /**
     * Reason this shows first is because if its only dish level discounts,
     * Then the cart value will already have the discount subtracted from it
     * If users sees discount after cart when its already included in the cart value
     * They may question why it shows like this and why is the cart value not reduced
     * Alternative is to show discount coupon used elsewhere and only show discount line if non dish based discount
     */
    // Render cart + promo old discounts
    // The total discount that might be applied is the dish discount + promo_old_discount
    const totalDetail = orderTotals.cartDetail({ dishes });
    const totalDiscount = (promoDiscount || 0) + totalDetail.discount;
    if (totalDiscount > 0) {
        details.push({
            l: React.createElement("span", { className: "text-md" },
                "Discount",
                !!promoCode && `: ${promoCode}`),
            v: React.createElement("span", { className: "text-md" },
                "-",
                formatCurrency(totalDiscount)),
        });
    }
    // Render Cart Value
    if (!hideCartTotalIfSame ||
        (hideCartTotalIfSame && (!totalsAreSame || fees.length > 0 || discounts.length > 0))) {
        details.push({
            l: React.createElement("span", { className: "text-md" }, "Cart"),
            v: React.createElement("span", { className: "text-md" }, formatCurrency(cart)),
        });
    }
    // Render Tip
    if (tip > 0) {
        details.push({
            l: React.createElement("span", { className: "text-md" }, "Tip"),
            v: React.createElement("span", { className: "text-md" }, formatCurrency(tip)),
        });
    }
    // Render Discounts
    for (const discount of discounts) {
        details.push({
            l: (() => {
                if (!!discountsOnRemove && (discountsRemovable || []).indexOf(discount.id) !== -1) {
                    return (React.createElement("span", { className: "flex items-center text-md" },
                        React.createElement(IoMdCloseCircleOutline, { className: "mr-2 text-lg cursor-pointer", onClick: () => discountsOnRemove(discount.id) }),
                        discount.name));
                }
                return React.createElement("span", { className: "text-md" }, discount.name);
            })(),
            v: React.createElement("span", { className: "text-md" },
                "-",
                formatCurrency(discount.value)),
        });
    }
    // Render Fees
    for (const fee of fees) {
        details.push({
            l: (() => {
                if (fee.is_voided) {
                    return (React.createElement("s", null,
                        React.createElement("span", { className: "text-md" }, fee.name)));
                }
                if (!!feesOnRemove && (feesRemovable || []).indexOf(fee.id) !== -1) {
                    return (React.createElement("span", { className: "flex items-center text-md" },
                        React.createElement(IoMdCloseCircleOutline, { className: "mr-2 text-lg cursor-pointer", onClick: () => feesOnRemove(fee.id) }),
                        fee.name));
                }
                return React.createElement("span", { className: "text-md" }, fee.name);
            })(),
            v: (() => {
                const d = fee.value === 0 ? "FREE" : formatCurrency(fee.value);
                if (fee.is_voided) {
                    return (React.createElement("s", null,
                        React.createElement("span", { className: "text-md" }, d)));
                }
                return React.createElement("span", { className: "text-md" }, d);
            })(),
        });
    }
    // Render Tax
    if (!hideTax) {
        details.push({
            l: React.createElement("span", { className: "text-md" }, "GST (15%) inc. in price"),
            v: React.createElement("span", { className: "text-md" }, formatCurrency(taxValue)),
        });
    }
    // Render rounding
    if (Math.abs(rounded) > 0) {
        details.push({
            l: React.createElement("span", { className: "text-md" }, "Rounding"),
            v: (React.createElement("span", { className: "text-md" },
                rounded < 0 ? "-" : "+",
                formatCurrency(Math.abs(rounded)))),
        });
    }
    // Render total
    details.push({
        l: React.createElement("span", { className: "font-bold" }, "Total"),
        v: React.createElement("span", { className: "font-bold" }, formatCurrency(total)),
    });
    return (React.createElement("div", { style: { paddingTop: props.disablePaddingTop ? "0px" : "8px" } },
        React.createElement(DetailRowList, { spacing: 8, items: details })));
});
//# sourceMappingURL=order-totals.js.map